import React from 'react';
import {Link as RouterLink} from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {AppBar, Box, Button, Divider, Hidden, Link, makeStyles, Toolbar, Typography} from '@material-ui/core';
import {APP_VERSION} from 'src/config';
import Logo from 'src/components/Logo';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.default,
    },
    toolbar: {
        height: 64
    },
    logo: {
        marginRight: theme.spacing(2),
        width: "75px",
        ...theme.palette.type === 'light' ? {
            filter: 'invert(19%) sepia(99%) saturate(4316%) hue-rotate(328deg) brightness(88%) contrast(91%)'
        } : {
            filter: 'invert(100%)'
        },
    },
    link: {
        fontWeight: theme.typography.fontWeightMedium,
        '& + &': {
            marginLeft: theme.spacing(2)
        }
    },
    divider: {
        width: 1,
        height: 32,
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2)
    }
}));

function TopBar({className, ...rest}) {
    const classes = useStyles();

    return (
        <AppBar
            className={clsx(classes.root, className)}
            color="default"
            {...rest}
        >
            <Toolbar className={classes.toolbar}>
                <RouterLink to="/">
                    <Logo className={classes.logo}/>
                </RouterLink>
                <Hidden mdDown>
                    <Typography
                        variant="caption"
                        color="textSecondary"
                    >
                        Version {' '} {APP_VERSION}
                    </Typography>
                </Hidden>
                <Box flexGrow={1}/>
                <Link
                    className={classes.link}
                    color="textSecondary"
                    component={RouterLink}
                    to="/app"
                    underline="none"
                    variant="body2"
                >
                    Dashboard
                </Link>
                <Divider className={classes.divider}/>
                <Button
                    color="secondary"
                    component="a"
                    href="/login"
                    variant="contained"
                    size="small"
                >
                    Log In
                </Button>
            </Toolbar>
        </AppBar>
    );
}

TopBar.propTypes = {
    className: PropTypes.string
};

export default TopBar;
